// extracted by mini-css-extract-plugin
export var background = "competitorPageHeader-module--background--b32eb";
export var competitorsPageRow = "competitorPageHeader-module--competitorsPageRow--aef7e";
export var container = "competitorPageHeader-module--container--1dfec";
export var ctaContainer = "competitorPageHeader-module--ctaContainer--10f55";
export var ctaWrap = "competitorPageHeader-module--ctaWrap--a0d38";
export var eyebrow = "competitorPageHeader-module--eyebrow--ab97f";
export var header = "competitorPageHeader-module--header--164cd";
export var headline = "competitorPageHeader-module--headline--7e3e7";
export var imageContainer = "competitorPageHeader-module--imageContainer--6c564";
export var subheading = "competitorPageHeader-module--subheading--76b15";